import React from "react";
import { Input, Image } from "@nextui-org/react";
import SearchIcon from "../assets/Svg/Search.svg";
import { isEmpty } from "lodash";
import SkeletonUI from "./Skeletons";
export default function ButtonSlider({
  selectedButton,
  setSelectedButton,
  inputSearch,
  setInputQuery,
  multiItems,
  selectionType,
  loading,
}) {
  const handleButtonSelect = (index, type) => {
    setSelectedButton((prevSelectedButton = []) => {
      if (type === "multiple") {
        if (index === "All") {
          return [];
        }

        // Remove "All" if another option is selected
        let newSelection = prevSelectedButton?.includes(index)
          ? prevSelectedButton?.filter((item) => item !== index)
          : [...prevSelectedButton?.filter((item) => item !== "All"), index];

        return newSelection;
      } else {
        return index; // Single selection
      }
    });
  };

  const sortedItems =
    !isEmpty(multiItems) &&
    (() => {
      const selectedIds = new Set(selectedButton);
      const selectedItems = multiItems.filter((item) =>
        selectedIds.has(item.id)
      );
      const remainingItems = multiItems.filter(
        (item) => !selectedIds.has(item.id)
      );
      return [...selectedItems, ...remainingItems];
      // return [
      //   ...selectedItems.sort((a, b) => a.name.localeCompare(b.name)),
      //   ...remainingItems.sort((a, b) => a.name.localeCompare(b.name)),
      // ];
    })();
  return (
    <React.Fragment>
      {inputSearch && (
        <div className="my-3">
          <Input
            isClearable
            type="text"
            label="Search"
            onChange={(e) => setInputQuery(e.target.value)}
            placeholder="Search For Products"
            onClear={() => setInputQuery("")}
            startContent={
              <Image
                isBlurred
                src={SearchIcon}
                alt="NextUI Album Cover"
                loading="lazy"
              />
            }
          />
        </div>
      )}
      <div className="flex flex-row items-center whitespace-nowrap">
        <div className="flex space-x-2 overflow-x-auto h-10 cursor-pointer">
          {loading ? (
            <SkeletonUI cardId="button" />
          ) : (
            <>
              <div
                className={`flex justify-center items-center px-3 py-1 text-textColor rounded-xl
                   ${
                     isEmpty(selectedButton)
                       ? "bg-[#4862EE] text-white"
                       : "bg-[#eceff2] text-[#668091]"
                   }`}
                onClick={() => handleButtonSelect("All", selectionType)}
              >
                All
              </div>
              {sortedItems &&
                sortedItems?.map((item, index) => (
                  <div
                    key={index}
                    onClick={() => handleButtonSelect(item.id, selectionType)}
                    className={`flex justify-center items-center px-3 py-1 text-textColor rounded-xl
               ${
                 selectedButton && selectedButton.includes(item?.id)
                   ? "bg-[#4862EE] text-white"
                   : "bg-[#eceff2] text-[#668091]"
               }`}
                  >
                    {item?.name}
                  </div>
                ))}
            </>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}
